import { useMemo } from 'react'
import { staticState } from '@wellesley/host-remote/common/staticState'
import { getDisplayUsername } from '@wellesley/user/helpers/getDisplayUsername'

type RendererProps = {
  raw: string
  type: string
  username: string
}

const useMentionExtension = (mentionPath: string) => {
  const { baseUrl } = staticState.get()

  const absoluteMentionPath = useMemo(
    () =>
      mentionPath.startsWith('http') ? mentionPath : `${baseUrl}${mentionPath}`,
    [baseUrl, mentionPath],
  )
  const extension = {
    name: 'mention',
    level: 'inline',
    start(src: string) {
      const match = src.match(/(?<!\w)@/)
      return match ? match.index : -1
    },
    tokenizer(src: string) {
      const rule = /^@(\w+)/
      const match = rule.exec(src)
      if (match) {
        return {
          type: 'mention',
          raw: match[0],
          username: match[1],
        }
      }
      return undefined
    },
    renderer({ username }: RendererProps) {
      return `<span class="h-card"><a class="u-url mention status-link" href="${absoluteMentionPath}${username}" title="${getDisplayUsername(username)}">@<span>${username}</span></a></span>`
    },
  }

  return extension
}

export default useMentionExtension
